import { useFormikContext } from 'formik';

import { ErrorField } from '@/components/error-field';
import { RequiredLabel } from '@/components/required-label';
import { Field } from '@/components/ui/field';
import { Input } from '@/components/ui/input';

import type { BatchCallFormValues } from '@/schemas/batch-call.schema';

import { useFormikError } from '@/lib/error';

export const BatchCallNameField = () => {
  const { getFieldProps } = useFormikContext<BatchCallFormValues>();
  const hasError = useFormikError();

  return (
    <div className="space-y-2">
      <Field aria-invalid={hasError('batchName')}>
        <RequiredLabel htmlFor="batchName">Batch Call Name</RequiredLabel>
        <Input
          id="batchName"
          placeholder="Enter batch call name"
          className="border-zinc-200"
          {...getFieldProps('batchName')}
          aria-invalid={hasError('batchName')}
        />
        <ErrorField name="batchName" />
      </Field>
    </div>
  );
};
